import React, { Component } from 'react';
import './style.css';

import State from '../State'


class SurveyQuestionAnswer extends Component {

  constructor(props) {
    super(props)

    this.handleAnswerClick = this.handleAnswerClick.bind(this)
  }

  handleAnswerClick(e) {
    e.stopPropagation()
    State.action('setAnswer', {
      section: this.props.section,
      question: this.props.question,
      answer: this.props.answer,
      answerIndex: this.props.answerIndex
    })
  }

  render() {
    var classes = 'survey-section-question-answer'


    if(this.props.question.chosenAnswer !== null) {
      // if)
      //   classes += ' chosen'
      // else {
      //   classes
      // }
      //
      classes += this.props.answerIndex === this.props.question.chosenAnswer ? ' chosen' : ' not-chosen'
    }

    let asterix = ''
    // if(this.props.answerIndex === this.props.question.originalChosenAnswer)
    //   asterix = '*'

    let answer = this.props.answer

    return (
      <div className={classes} onClick={this.handleAnswerClick}>
        <div className="image"><img src={"img/answers/" + answer.image + ".png" } alt={answer.text} /></div>
        <div className="text">{answer.text}{asterix}</div>
        <div className="description">{answer.description}</div>
      </div>
    );
  }
}

export default SurveyQuestionAnswer;



// WEBPACK FOOTER //
// ./src/SurveyQuestionAnswer/index.js